import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _CertificateSheets, _CertificateYears } from '../../../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idSelector: number | string;
    year: any;
    onChange: any;
    label?: string;
}

export const CertificateSheets = ({ idSelector, onChange, label, year }: Props) => {
    const CertificateSheets = useDataBean(_CertificateSheets);
    const [lista, setLista] = useState<string[]>([]);
    const [id, setID] = useState<string | number>(idSelector);

    useEffect(() => {
        getLista();
    }, [year]);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
        }
    }, [idSelector]);

    const setValue = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = e.target.value;
        setID(selectedValue);
        onChange(selectedValue); // lo envías como string
    };

    const getLista = () => {
        CertificateSheets.instance.getInfoForTaxCertificateSheets(year).then(
            (resp: any) => {
                // if (resp?.DataBeanProperties?.ObjectValue) {
                //     setLista(resp.DataBeanProperties.ObjectValue);
                // }}
                setLista(resp)
            }
        );
    };

    return (
        <>
            <label>{label ?? "Versión de Certificado:"}</label>
            <select className="form-select" value={id} onChange={setValue}>
                <option value="">...</option>
                {lista.map((item, index) => (
                    <option key={index} value={item}>
                        {item}
                    </option>
                ))}
            </select>
        </>
    );
};